import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkDeleteTicketDefinitionsByFilterRequest = {};
var _bulkDeleteTicketDefinitionsByFilterResponse = {};
var _changeCurrencyRequest = {};
var _changeCurrencyResponse = {};
var _countAvailableTicketDefinitionsRequest = {};
var _countAvailableTicketDefinitionsResponse = {};
var _countTicketDefinitionsRequest = {};
var _countTicketDefinitionsResponse = {};
var _createTicketDefinitionRequest = {
    ticketDefinition: '_ticketDefinition',
};
var _createTicketDefinitionResponse = {
    ticketDefinition: '_ticketDefinition',
};
var _deleteTicketDefinitionRequest = {};
var _deleteTicketDefinitionResponse = {};
var _getTicketDefinitionRequest = {};
var _getTicketDefinitionResponse = { ticketDefinition: '_ticketDefinition' };
var _queryAvailableTicketDefinitionsRequest = {};
var _queryAvailableTicketDefinitionsResponse = {
    ticketDefinitions: '_ticketDefinition',
};
var _queryTicketDefinitionsRequest = {};
var _queryTicketDefinitionsResponse = {
    ticketDefinitions: '_ticketDefinition',
};
var _reorderTicketDefinitionsRequest = {};
var _reorderTicketDefinitionsResponse = {};
var _salePeriod = {
    startDate: 'google.protobuf.Timestamp',
    endDate: 'google.protobuf.Timestamp',
};
var _ticketDefinition = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
    eventCreatedDate: 'google.protobuf.Timestamp',
    salePeriod: '_salePeriod',
};
var _updateTicketDefinitionRequest = {
    mask: 'google.protobuf.FieldMask',
    ticketDefinition: '_ticketDefinition',
};
var _updateTicketDefinitionResponse = {
    ticketDefinition: '_ticketDefinition',
};
function resolveWixEventsTicketdefV3TicketDefinitionManagementUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/events-ticket-definitions',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/events-ticket-definitions',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/events-ticket-definitions',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/events-ticket-definitions',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/events-ticket-definitions',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/events-ticket-definitions',
                destPath: '',
            },
        ],
        'events.wixapps.net': [
            {
                srcPath: '/_api/events-ticket-definitions',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Creates a ticket definition. Allowed to create up to 100 definitions per event. */
export function createTicketDefinition(payload) {
    var _a = serializer(_createTicketDefinitionRequest, { _salePeriod: _salePeriod, _ticketDefinition: _ticketDefinition }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createTicketDefinitionResponse, {
        _salePeriod: _salePeriod,
        _ticketDefinition: _ticketDefinition,
    }).fromJSON;
    function __createTicketDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.CreateTicketDefinition',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createTicketDefinition.fromReq = fromReq;
    __createTicketDefinition.__isAmbassador = true;
    return __createTicketDefinition;
}
/**
 * Updates a ticket definition.
 *
 * Each time the ticket definition is updated, `revision` increments by 1. The existing `revision` must be included when updating the ticket definition. This ensures you're working with the latest ticket definition and prevents unintended overwrites.
 */
export function updateTicketDefinition(payload) {
    var _a = serializer(_updateTicketDefinitionRequest, { _salePeriod: _salePeriod, _ticketDefinition: _ticketDefinition }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateTicketDefinitionResponse, {
        _salePeriod: _salePeriod,
        _ticketDefinition: _ticketDefinition,
    }).fromJSON;
    function __updateTicketDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'PATCH',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.UpdateTicketDefinition',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions/{ticketDefinition.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateTicketDefinition.fromReq = fromReq;
    __updateTicketDefinition.__isAmbassador = true;
    return __updateTicketDefinition;
}
/** Retrieves a ticket definition by ID. */
export function getTicketDefinition(payload) {
    var _a = serializer(_getTicketDefinitionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTicketDefinitionResponse, {
        _salePeriod: _salePeriod,
        _ticketDefinition: _ticketDefinition,
    }).fromJSON;
    function __getTicketDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'GET',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.GetTicketDefinition',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions/{ticketDefinitionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTicketDefinition.fromReq = fromReq;
    __getTicketDefinition.__isAmbassador = true;
    return __getTicketDefinition;
}
/** Permanently deletes a ticket definition. */
export function deleteTicketDefinition(payload) {
    var _a = serializer(_deleteTicketDefinitionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteTicketDefinitionResponse, {}).fromJSON;
    function __deleteTicketDefinition(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'DELETE',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.DeleteTicketDefinition',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions/{ticketDefinitionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteTicketDefinition.fromReq = fromReq;
    __deleteTicketDefinition.__isAmbassador = true;
    return __deleteTicketDefinition;
}
/**
 * Changes ticket definitions order in an event dashboard and the list of available tickets in the ticket picker.
 * > **Note:** It is possible to use both `beforeTicketDefinitionId` and `afterTicketDefinitionId` at the same time but only the last one defined will be executed.
 */
export function reorderTicketDefinitions(payload) {
    var _a = serializer(_reorderTicketDefinitionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_reorderTicketDefinitionsResponse, {}).fromJSON;
    function __reorderTicketDefinitions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.ReorderTicketDefinitions',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions/reorder',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __reorderTicketDefinitions.fromReq = fromReq;
    __reorderTicketDefinitions.__isAmbassador = true;
    return __reorderTicketDefinitions;
}
/**
 * Retrieves a list of ticket definitions, given the provided paging, filtering, and sorting.
 * Query Ticket Definitions runs with these defaults, which you can override:
 * - `createdDate` is sorted in `ASC` order
 * - `paging.limit` is `100`
 * - `paging.offset` is `0`
 * <br>
 * For field support for filters and sorting, see [Ticket Definitions: Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/events/ticket-definition-v3/filter-and-sort).
 * To learn about working with _Query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language).
 */
export function queryTicketDefinitions(payload) {
    var _a = serializer(_queryTicketDefinitionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryTicketDefinitionsResponse, {
        _salePeriod: _salePeriod,
        _ticketDefinition: _ticketDefinition,
    }).fromJSON;
    function __queryTicketDefinitions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.QueryTicketDefinitions',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryTicketDefinitions.fromReq = fromReq;
    __queryTicketDefinitions.__isAmbassador = true;
    return __queryTicketDefinitions;
}
/**
 * Retrieves a list of available (visible) ticket definitions. Differs from QueryTicketDefinitions by these points:
 * - only visible tickets are returned (not(`hidden`))
 * - required permission is less strict (allowed for site visitors)
 * - `salesDetails` always empty
 */
export function queryAvailableTicketDefinitions(payload) {
    var _a = serializer(_queryAvailableTicketDefinitionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryAvailableTicketDefinitionsResponse, { _salePeriod: _salePeriod, _ticketDefinition: _ticketDefinition }).fromJSON;
    function __queryAvailableTicketDefinitions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.QueryAvailableTicketDefinitions',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions/available/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryAvailableTicketDefinitions.fromReq = fromReq;
    __queryAvailableTicketDefinitions.__isAmbassador = true;
    return __queryAvailableTicketDefinitions;
}
/**
 * Counts ticket definitions by the `saleStatus` and `hidden` fields. <br> <br>
 * To learn about working with _query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function countTicketDefinitions(payload) {
    var _a = serializer(_countTicketDefinitionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countTicketDefinitionsResponse, {}).fromJSON;
    function __countTicketDefinitions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.CountTicketDefinitions',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countTicketDefinitions.fromReq = fromReq;
    __countTicketDefinitions.__isAmbassador = true;
    return __countTicketDefinitions;
}
/**
 * Counts available ticket definitions. <br> <br>
 * To learn about working with _query_ endpoints, see [API Query Language](https://dev.wix.com/api/rest/getting-started/api-query-language) and [Field Projection](https://dev.wix.com/api/rest/getting-started/field-projection).
 */
export function countAvailableTicketDefinitions(payload) {
    var _a = serializer(_countAvailableTicketDefinitionsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countAvailableTicketDefinitionsResponse, {}).fromJSON;
    function __countAvailableTicketDefinitions(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.CountAvailableTicketDefinitions',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions/available/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countAvailableTicketDefinitions.fromReq = fromReq;
    __countAvailableTicketDefinitions.__isAmbassador = true;
    return __countAvailableTicketDefinitions;
}
/**
 * Deletes multiple ticket definitions.
 *
 * All ticket definitions that meet the specified `filter` criteria are deleted.
 */
export function bulkDeleteTicketDefinitionsByFilter(payload) {
    var _a = serializer(_bulkDeleteTicketDefinitionsByFilterRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteTicketDefinitionsByFilterResponse, {}).fromJSON;
    function __bulkDeleteTicketDefinitionsByFilter(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.BulkDeleteTicketDefinitionsByFilter',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/bulk/ticket-definitions/delete',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteTicketDefinitionsByFilter.fromReq = fromReq;
    __bulkDeleteTicketDefinitionsByFilter.__isAmbassador = true;
    return __bulkDeleteTicketDefinitionsByFilter;
}
/** Changes the currency for all tickets (per event). */
export function changeCurrency(payload) {
    var _a = serializer(_changeCurrencyRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_changeCurrencyResponse, {}).fromJSON;
    function __changeCurrency(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.events.v3.ticket_definition',
            method: 'POST',
            methodFqn: 'wix.events.ticketdef.v3.TicketDefinitionManagement.ChangeCurrency',
            url: resolveWixEventsTicketdefV3TicketDefinitionManagementUrl({
                protoPath: '/v3/ticket-definitions/currency',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __changeCurrency.fromReq = fromReq;
    __changeCurrency.__isAmbassador = true;
    return __changeCurrency;
}
//# sourceMappingURL=http.impl.js.map